import React from 'react';
import Title from '../../../element/title';
import clone from 'clone';
import url from '../../../urlhandler/urlHandlerActions';
import Select from 'react-select';
import { findIndex } from 'underscore';

const $ = jQuery;
const RE = REBUILDER;

class SelectBoxPreview extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    this.state = {
      'values': [],
      'options': [],
      'toogle': true,
    };
    this.changeToogle = this.changeToogle.bind(this);
  }
  componentWillMount() {
    const index = findIndex(window.searchArray, { viewType: 'select' });
    if (index !== -1) {
      this.setState({ values: window.searchArray[index].value });
    }
  }
  componentWillReceiveProps(nextprops) {
    this.block = nextprops.block;
  }
  handleChange(multi, values) {
    if (values === null) {
      url.push({
        'searchItem': this.searchItem,
        'searchType': this.searchType,
      'searchField': 'selectBox',
        'values': [],
      });
      return;
    }
    const valuesSelected = [];
    const selectedindex = findIndex(this.options, { key: parseInt(values.value, 10) });
    if (selectedindex !== -1) {
      valuesSelected.push(this.options[selectedindex]);
      const value = values.label;
      this.setState({ values: value });
    }
    // this.setState({ 'values': _.pluck(values, 'key') });
    url.push({
      'searchItem': this.searchItem,
      'searchType': this.searchType,
      'values': valuesSelected,
      'searchField': 'selectBox',
    });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  render() {
    this.helperData = clone(this.props.helperData);
    this.block = this.props.block;
    this.options = [];
    let values = this.state.values;
    if (this.block.selectedDataType !== null) {
      // taxonomies
      if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
        this.options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
        this.searchType = 'taxonomies';
        this.searchItem = this.block.selectedTaxonomy;
      } else {
        this.options = this.props.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
        this.searchType = 'metakeys';
        this.searchItem = this.block.selectedMetakey;
      }
      // url case
      if (this.props.urlData.hasOwnProperty(this.searchItem)) {
        if (this.state.values.length < 1) {
          values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
        }
      } else {
        values = [];
      }
    }
    if ($.isArray(values) === false) {
      const newValues = [];
      newValues.push(values);
      values = clone(newValues);
    }
    let selectedValue = null;
    this.selectOptions = [];
    this.options.map((item) => {
      if (item.slug.toString() !== values[0]) {
        this.selectOptions.push({
          label: item.slug,
          value: item.key,
        });
      } else {
        this.selectOptions.push({
          label: item.slug,
          value: item.key,
        });
        selectedValue = item.key;
      }
    });
    const checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
    const HelperClass = this.state.toogle ? 'single-component' : '';
    return (<div className={checkBoxClassName}>
      <Title
        title={this.props.block.title}
        subtitle={this.props.block.subtitle}
        toogle= {this.state.toogle}
        onToogle = {this.changeToogle}
        selectedToogleViewType = {this.props.block.selectedToogleViewType}
      />

      <div className={HelperClass}>
      { this.selectOptions !== undefined && this.selectOptions.length ?
        <div>
      { this.state.toogle && this.selectOptions.length ?
          <div>
            <Select name="form-field-name"
              options={this.selectOptions}
              value={selectedValue}
              onChange={this.handleChange.bind(this, true)}
            />
          </div> : null }
        </div> : null}
      {this.selectOptions.length === 0 && this.state.toogle ?
        <div className="rq-no-attributes-found">
          <h3>{API.LANG.NO_ATTR_FOUND}</h3>
        </div> : ''}
      </div>
    </div>);
  }
}

SelectBoxPreview.propTypes = {
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'helperData': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default SelectBoxPreview;



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/search/default/selectboxpreview.js